import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","height":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_yrp_circle_logo = _resolveComponent("yrp-circle-logo")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_yrp_circle_logo, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.load())),
              class: "auto",
              style: {"width":"60vw","height":"60vw","max-width":"60vw","max-height":"60vw"}
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}